import { render, staticRenderFns } from "./RegionStatisticBuldingList.vue?vue&type=template&id=3c8d64ee&scoped=true&"
import script from "./RegionStatisticBuldingList.vue?vue&type=script&lang=js&"
export * from "./RegionStatisticBuldingList.vue?vue&type=script&lang=js&"
import style0 from "./RegionStatisticBuldingList.vue?vue&type=style&index=0&id=3c8d64ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8d64ee",
  null
  
)

export default component.exports